import { throwOnlyInDev } from '~/util/throwOnlyInDev';

const currencyCodeToSymbolMap: Record<string, string> = {
  usd: '$',
  eur: '€',
  gbp: '£',
};

const getSymbolFromCurrency = (code: string) => {
  const normalizedCode = code.toLowerCase();

  if (!currencyCodeToSymbolMap[normalizedCode]) {
    throwOnlyInDev(new Error(`Currency code ${code} is not supported`));
  }

  return currencyCodeToSymbolMap[normalizedCode];
};

export default getSymbolFromCurrency;
